import type { BaseFile } from 'config'
import { accountTypes } from 'config/user.type.constants'
import { ActionType } from 'pages/Admin/AdminTools/Configuration/LoanSubmission/types'
import type { UserInfo } from 'pages/ManageAccounts'
import { accountTypeTitleForName } from 'reducers/partyNames'

export enum TaskStatus {
  ACTIVE = 'active',
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  OVERDUE = 'overdue',
  ON_HOLD = 'onHold',
}
export const taskProjectLoanNumber = {
  BrokerVerification: 1,
  FundDrawRequest: 2,
  Reminders: 3,
  LoanScenarios: 4,
}

export const taskProjectID = {
  DefaultProjectId: 1,
  BrokerVerification: 2,
  FundDrawRequest: 3,
  Reminders: 4,
  LoanScenarios: 5,
}

export const NonLoanTaskProjectIds = [
  taskProjectID.BrokerVerification,
  taskProjectID.FundDrawRequest,
  taskProjectID.Reminders,
  taskProjectID.LoanScenarios,
]

export const TaskAssigneeOptions = (): Record<string, string> => ({
  self_underwriter: `[Loan] ${accountTypeTitleForName('Underwriter')}`,
  self_account_executive: `[Loan] ${accountTypeTitleForName('Account Executive')}`,
  self_broker: `[Loan] ${accountTypeTitleForName('Broker')}`,
  self_loan_officer: '[Loan] Loan Officer',
  self_loan_processor: '[Loan] Loan Processor',
  self_account_manager: `[Loan] ${accountTypeTitleForName('Account Manager')}`,
  self_creator: '[Loan] Creator',
  self_appraiser: '[Loan] Appraiser',
  self_closer: '[Loan] Closer',
  loan_borrower: '[Loan] Borrower',
  ...accountTypes,
})

export const EmailAssigneeOptions = (accountType?: ActionType): Record<string, string> => {
  if (accountType == ActionType.UserAccounts)
    return {
      self_user: '[User] Individual User',
      ...accountTypes,
    }

  return {
    self_underwriter: `[Loan] ${accountTypeTitleForName('Underwriter')}`,
    self_account_executive: `[Loan] ${accountTypeTitleForName('Account Executive')}`,
    self_broker: `[Loan] ${accountTypeTitleForName('Broker')}`,
    self_loan_officer: '[Loan] Loan Officer',
    self_loan_processor: '[Loan] Loan Processor',
    self_account_manager: `[Loan] ${accountTypeTitleForName('Account Manager')}`,
    self_creator: '[Loan] Creator',
    self_appraiser: '[Loan] Appraiser',
    self_closer: '[Loan] Closer',
    loan_borrower: '[Loan] Borrower',
    ...accountTypes,
  }
}

export interface Project {
  id: number

  name: string

  user: UserInfo

  createdAt: Date

  updatedAt: Date
}

export interface TaskAssignedTo {
  id: number

  task: Task

  value: string

  displayValue?: string

  createdAt: Date
}

export interface Task {
  id: number

  project: Project

  assignedTo: TaskAssignedTo[]

  assignedToManager: TaskAssignedTo[]

  replyCcUser: string[]

  loanNumber: number

  byteproFileName: number

  no: number

  taskTemplateNo: number

  byteproTaskID: number

  borrowerName: string

  description: string

  dueDate: string

  dueDateSource?: string

  note: string

  files: BaseFile[]

  status: TaskStatus

  creator: UserInfo

  reassignor?: UserInfo

  completor: UserInfo

  completedDate: string

  additionalInfo: Record<string, string | number>

  deleted: boolean

  createdAt: Date

  updatedAt: Date
}

export const formatTaskAssignedTo = (
  values: Array<{ value: string; displayValue?: string }>,
  assignedToList: Record<string, string>,
  loanPartyAssigneeEmails?: Record<string, string>,
) =>
  values
    .map(
      ({ value, displayValue }) =>
        displayValue || loanPartyAssigneeEmails?.[value] || assignedToList[value] || value,
    )
    .join(', ')
